// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.cost {
  width: 100%;
  display: flex;
  flex-wrap: wrap;
  align-items: flex-start;
  gap: 30px;
}

.cost__menu {
  max-width: 400px;
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 16px;
  border-radius: 30px;
  border: 1px solid #60656e;
  padding: 30px;
}

.cost__menu > a {
  width: 100%;
  height: 56px;
  display: flex;
  align-items: center;
  padding: 0 40px;
  border-radius: 8px;
  background: #60656e;
  color: var(--White, #fff);
  font-size: 16px;
  font-weight: 600;
}

.cost__menu > a.active 
{
      background: #0c6b60;
}

.cost__content {
  width: calc(100% - 430px);
  display: flex;
  flex-direction: column;
  gap: 16px;
  overflow: hidden;
}

.cost__header {
  width: 100%;
  display: flex;
  align-items: center;
  gap: 8px;
}

.cost__header > h2 {
  color: #777f87;
  font-size: 24px;
  font-weight: 600;
  padding-right: 22px;
  flex: 1 1;
}

.cost__header > button {
  display: flex;
  align-items: center;
  height: 35px;
  padding: 0 17px;
  background: #0c6b60;
  border: none;
  cursor: pointer;
  gap: 5px;
  border-radius: 8px;

  color: #fff;
  font-size: 14px;
  font-weight: 500;
}

.cost__header > div > button
{
  display: flex;
  align-items: center;
  height: 35px;
  padding: 0 17px;
  background: #0c6b60;
  border: none;
  cursor: pointer;
  gap: 5px;
  border-radius: 8px;

  color: #fff;
  font-size: 14px;
  font-weight: 500;
}

/* ------- cost__list -------- */

.cost__list-container {
  width: 100%;
  overflow: hidden;
  overflow: auto;
}

.cost__list {
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 16px;
  list-style: none;
}

.cost__list > li {
  width: 100%;
  display: flex;
  align-items: center;
}

.cost__list > li .w280 {
  width: 280px;
}
.cost__list > li .w100 {
  width: 100px;
}

.cost__list-header {
  width: 100%;
  height: 50px;
  display: flex;
  align-items: center;
}

.cost__list-header > p {
  color: #b2bac6;
  font-size: 10px;
  font-weight: 500;
  text-align: center;
  border-right: 1px solid #b2bac6;
  padding: 0 10px;
}

.cost__list-header > :nth-child(2) {
  border: none;
  text-align: start;
}

.cost__list-item {
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.cost__list-item-content {
  width: 100%;
  display: flex;
  align-items: center;
  height: 65px;
  background: #dde1eb;
  border-radius: 8px;
}

.cost__list-item-content > p {
  color: #777f87;
  font-size: 14px;
  font-weight: 500;
  padding: 0 10px;
  border-right: 1px solid #b2bac6;
}

.cost__list-item-content > p small 
{
    padding: 4px 8px;
    border-radius: 4px;
    background: #60656e;
    color: #fff;
    font-size: 12px;
    font-weight: 700;
    font-style: normal;
    margin: 7px;
}

.cost__list-item-content > :nth-child(2) {
  border: none;
}

.cost__list-item-content > div {
  flex: 1 1;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 10px;
  padding: 0 10px;
}

.cost__list-item-content > div > button {
  padding: 10px 20px;
  border: 1px solid #b2bac6;
  border-radius: 8px;
  background: transparent;
  cursor: pointer;
}

.cost__list-item-content > div > :first-child {
  border-color: #0c6b60;
  color: #0c6b60;
  font-size: 14px;
  font-weight: 500;
}

.cost__list-item-content > div > :last-child {
  border-color: #e0383d;
  color: #e0383d;
  text-align: center;
  font-size: 14px;
  font-weight: 500;
}

.cost__list-item-form {
  position: relative;
  width: 100%;
  display: flex;
  border-radius: 8px;
  background: #dde1eb;
  padding: 30px;
  gap: 30px;
  display: none;
  animation: popup 0.1s ease-in-out;
}

.cost__list-item-form.active {
  display: flex;
}

@keyframes popup {
  0% {
    opacity: 0;
    transform: translateY(-50px);
  }
  100% {
    opacity: 1;
    transform: translateY(0);
  }
}

.cost__list-item-form-close {
  position: absolute;
  top: 15px;
  right: 15px;
  cursor: pointer;
  background: transparent;
  border: none;
  font-size: 20px;
}

.cost__list-item-form > figure {
  position: relative;
  width: 281px;
  height: 281px;
  border-radius: 8px;
  background: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
}

.cost__list-item-form > figure.active > img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  border-radius: 8px;
}

.cost__list-item-form > figure label {
  position: absolute;
  bottom: 15px;
  width: calc(100% - 30px);
  height: 40px;
  border-radius: 8px;
  background: #a7acb7;
  display: flex;
  align-items: center;
  justify-content: center;

  color: var(--White, #fff);
  font-size: 16px;
  font-weight: 600;
  cursor: pointer;
}

.cost__list-item-form-inputs {
  width: calc(100% - 311px);
  display: flex;
  flex-direction: column;
  gap: 16px;
  padding: 0 0 15px 0;
}

.cost__list-item-form-inputs input {
  width: 100%;
  height: 56px;
  padding: 0 20px;
  border-radius: 8px;
  font-size: 16px;
  font-weight: 500;
}

.cost__list-item-form-inputs textarea, .cost__form .cost__form-inputs textarea {
   width: 100%;
  height: 137px;
  padding: 10px;
  border-radius: 8px;
  font-size: 16px;
  font-weight: 500;
  border: none;
  outline: none;
}

.cost__list-item-form-inputs.v2 {
  width: 100%;
  display: flex;
  flex-direction: row;
  gap: 16px;
}

.cost__list-item-form-inputs.v2 > input {
  width: calc((100% - 16px) / 2);
}

/* ------- cost__form ---------- */
.cost__form {
  width: 100%;
  height: 0px;
  display: flex;
  background: #dde1eb;
  padding: 0px 30px;
  border-radius: 8px;
  gap: 30px;
  overflow: hidden;
  transition: all 0.2s ease-in-out;
}

.cost__form.active {
  height: 341px;
  padding: 30px;
}

.cost__form.height_500.active
{
  height: 500px;
}

.cost__form > figure {
  position: relative;
  width: 281px;
  height: 281px;
  border-radius: 8px;
  background: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
}

.cost__form > figure > img.active {
  width: 100%;
  height: 100%;
  object-fit: cover;
  border-radius: 8px;
}

.cost__form > figure label {
  position: absolute;
  bottom: 15px;
  width: calc(100% - 30px);
  height: 40px;
  border-radius: 8px;
  background: #a7acb7;
  display: flex;
  align-items: center;
  justify-content: center;

  color: var(--White, #fff);
  font-size: 16px;
  font-weight: 600;
  cursor: pointer;
}

.cost__form-inputs {
  width: calc(100% - 311px);
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.cost__form-inputs > input {
  width: 100%;
  height: 56px;
  padding: 0 20px;
  border-radius: 8px;
  font-size: 16px;
  font-weight: 500;
}

.cost__form-inputs > div {
  width: 100%;
  display: flex;
  flex-direction: row;
  gap: 16px;
}

.cost__form-inputs > div > button {
  width: calc((100% - 16px) / 2);
  height: 56px;
  padding: 0;
  border: none;
  border-radius: 8px;
  background: #0c6b60;
  color: var(--White, #fff);
  font-size: 16px;
  font-weight: 600;
  cursor: pointer;
}

.cost__form-inputs > div > button[type="button"] {
  background: #e0383d;
}

@media (max-width: 1024px) {
  .cost__menu {
    display: none;
  }

  .cost__content {
    width: 100%;
  }
}

@media (max-width: 650px) {
  .cost__header {
    flex-wrap: wrap-reverse;
    gap: 8px;
  }

  .cost__header > h2 {
    inline-size: 100%;
  }

  .cost__header > button {
    width: calc((100% - 16px) / 3);
  }

  .cost__header > div > button {
    width: calc((100% - 16px) / 3);
  }

  .cost__list > li {
    width: 100%;
    display: flex;
    align-items: center;
    flex-wrap: wrap;
  }

  .cost__list-header > :nth-child(1) {
    width: calc(70% - 20px) !important;
    text-align: left;
    padding: 0 10px;
  }

  .cost__list-header > :nth-child(2) {
    width: 30% !important;
    padding: 0 10px;
  }

  .cost__list-item-content > :nth-child(1) {
    width: calc(70% - 20px) !important;
    padding: 0 10px;
  }

  .cost__list-item-content > :nth-child(2) {
    width: 30% !important;
    padding: 0 10px;
  }

  .cost__list-item-content {
    height: auto;
    flex-wrap: wrap;
    gap: 20px;
    padding: 15px 0;
  }

  .cost__list-item-content > div {
    width: 100%;
    padding: 0 10px;
  }

  .cost__list-item-content > div > button {
    max-width: 180px;
    width: calc((100% - 10px) / 2);
    height: 30px;
    padding: 0;
    font-size: 12px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/pages/admin/cost/cost.css"],"names":[],"mappings":"AAAA;EACE,WAAW;EACX,aAAa;EACb,eAAe;EACf,uBAAuB;EACvB,SAAS;AACX;;AAEA;EACE,gBAAgB;EAChB,WAAW;EACX,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,mBAAmB;EACnB,yBAAyB;EACzB,aAAa;AACf;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,kBAAkB;EAClB,mBAAmB;EACnB,yBAAyB;EACzB,eAAe;EACf,gBAAgB;AAClB;;AAEA;;MAEM,mBAAmB;AACzB;;AAEA;EACE,yBAAyB;EACzB,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,SAAO;AACT;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,eAAe;EACf,mBAAmB;EACnB,YAAY;EACZ,eAAe;EACf,QAAQ;EACR,kBAAkB;;EAElB,WAAW;EACX,eAAe;EACf,gBAAgB;AAClB;;AAEA;;EAEE,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,eAAe;EACf,mBAAmB;EACnB,YAAY;EACZ,eAAe;EACf,QAAQ;EACR,kBAAkB;;EAElB,WAAW;EACX,eAAe;EACf,gBAAgB;AAClB;;AAEA,gCAAgC;;AAEhC;EACE,WAAW;EACX,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,YAAY;AACd;AACA;EACE,YAAY;AACd;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,+BAA+B;EAC/B,eAAe;AACjB;;AAEA;EACE,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,+BAA+B;AACjC;;AAEA;;IAEI,gBAAgB;IAChB,kBAAkB;IAClB,mBAAmB;IACnB,WAAW;IACX,eAAe;IACf,gBAAgB;IAChB,kBAAkB;IAClB,WAAW;AACf;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,SAAO;EACP,aAAa;EACb,mBAAmB;EACnB,yBAAyB;EACzB,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,yBAAyB;EACzB,kBAAkB;EAClB,uBAAuB;EACvB,eAAe;AACjB;;AAEA;EACE,qBAAqB;EACrB,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;EACrB,cAAc;EACd,kBAAkB;EAClB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,aAAa;EACb,kBAAkB;EAClB,mBAAmB;EACnB,aAAa;EACb,SAAS;EACT,aAAa;EACb,iCAAiC;AACnC;;AAEA;EACE,aAAa;AACf;;AAEA;EACE;IACE,UAAU;IACV,4BAA4B;EAC9B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,eAAe;EACf,uBAAuB;EACvB,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,aAAa;EACb,kBAAkB;EAClB,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,wBAAwB;EACxB,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;;EAEvB,yBAAyB;EACzB,eAAe;EACf,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,yBAAyB;EACzB,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,eAAe;EACf,kBAAkB;EAClB,eAAe;EACf,gBAAgB;AAClB;;AAEA;GACG,WAAW;EACZ,aAAa;EACb,aAAa;EACb,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,YAAY;EACZ,aAAa;AACf;;AAEA;EACE,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,8BAA8B;AAChC;;AAEA,kCAAkC;AAClC;EACE,WAAW;EACX,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,iBAAiB;EACjB,kBAAkB;EAClB,SAAS;EACT,gBAAgB;EAChB,gCAAgC;AAClC;;AAEA;EACE,aAAa;EACb,aAAa;AACf;;AAEA;;EAEE,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,aAAa;EACb,kBAAkB;EAClB,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,wBAAwB;EACxB,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;;EAEvB,yBAAyB;EACzB,eAAe;EACf,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,yBAAyB;EACzB,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,eAAe;EACf,kBAAkB;EAClB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,8BAA8B;EAC9B,YAAY;EACZ,UAAU;EACV,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,yBAAyB;EACzB,eAAe;EACf,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE;IACE,aAAa;EACf;;EAEA;IACE,WAAW;EACb;AACF;;AAEA;EACE;IACE,uBAAuB;IACvB,QAAQ;EACV;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,8BAA8B;EAChC;;EAEA;IACE,8BAA8B;EAChC;;EAEA;IACE,WAAW;IACX,aAAa;IACb,mBAAmB;IACnB,eAAe;EACjB;;EAEA;IACE,kCAAkC;IAClC,gBAAgB;IAChB,eAAe;EACjB;;EAEA;IACE,qBAAqB;IACrB,eAAe;EACjB;;EAEA;IACE,kCAAkC;IAClC,eAAe;EACjB;;EAEA;IACE,qBAAqB;IACrB,eAAe;EACjB;;EAEA;IACE,YAAY;IACZ,eAAe;IACf,SAAS;IACT,eAAe;EACjB;;EAEA;IACE,WAAW;IACX,eAAe;EACjB;;EAEA;IACE,gBAAgB;IAChB,8BAA8B;IAC9B,YAAY;IACZ,UAAU;IACV,eAAe;EACjB;AACF","sourcesContent":[".cost {\n  width: 100%;\n  display: flex;\n  flex-wrap: wrap;\n  align-items: flex-start;\n  gap: 30px;\n}\n\n.cost__menu {\n  max-width: 400px;\n  width: 100%;\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n  border-radius: 30px;\n  border: 1px solid #60656e;\n  padding: 30px;\n}\n\n.cost__menu > a {\n  width: 100%;\n  height: 56px;\n  display: flex;\n  align-items: center;\n  padding: 0 40px;\n  border-radius: 8px;\n  background: #60656e;\n  color: var(--White, #fff);\n  font-size: 16px;\n  font-weight: 600;\n}\n\n.cost__menu > a.active \n{\n      background: #0c6b60;\n}\n\n.cost__content {\n  width: calc(100% - 430px);\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n  overflow: hidden;\n}\n\n.cost__header {\n  width: 100%;\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.cost__header > h2 {\n  color: #777f87;\n  font-size: 24px;\n  font-weight: 600;\n  padding-right: 22px;\n  flex: 1;\n}\n\n.cost__header > button {\n  display: flex;\n  align-items: center;\n  height: 35px;\n  padding: 0 17px;\n  background: #0c6b60;\n  border: none;\n  cursor: pointer;\n  gap: 5px;\n  border-radius: 8px;\n\n  color: #fff;\n  font-size: 14px;\n  font-weight: 500;\n}\n\n.cost__header > div > button\n{\n  display: flex;\n  align-items: center;\n  height: 35px;\n  padding: 0 17px;\n  background: #0c6b60;\n  border: none;\n  cursor: pointer;\n  gap: 5px;\n  border-radius: 8px;\n\n  color: #fff;\n  font-size: 14px;\n  font-weight: 500;\n}\n\n/* ------- cost__list -------- */\n\n.cost__list-container {\n  width: 100%;\n  overflow: hidden;\n  overflow: auto;\n}\n\n.cost__list {\n  width: 100%;\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n  list-style: none;\n}\n\n.cost__list > li {\n  width: 100%;\n  display: flex;\n  align-items: center;\n}\n\n.cost__list > li .w280 {\n  width: 280px;\n}\n.cost__list > li .w100 {\n  width: 100px;\n}\n\n.cost__list-header {\n  width: 100%;\n  height: 50px;\n  display: flex;\n  align-items: center;\n}\n\n.cost__list-header > p {\n  color: #b2bac6;\n  font-size: 10px;\n  font-weight: 500;\n  text-align: center;\n  border-right: 1px solid #b2bac6;\n  padding: 0 10px;\n}\n\n.cost__list-header > :nth-child(2) {\n  border: none;\n  text-align: start;\n}\n\n.cost__list-item {\n  width: 100%;\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n}\n\n.cost__list-item-content {\n  width: 100%;\n  display: flex;\n  align-items: center;\n  height: 65px;\n  background: #dde1eb;\n  border-radius: 8px;\n}\n\n.cost__list-item-content > p {\n  color: #777f87;\n  font-size: 14px;\n  font-weight: 500;\n  padding: 0 10px;\n  border-right: 1px solid #b2bac6;\n}\n\n.cost__list-item-content > p small \n{\n    padding: 4px 8px;\n    border-radius: 4px;\n    background: #60656e;\n    color: #fff;\n    font-size: 12px;\n    font-weight: 700;\n    font-style: normal;\n    margin: 7px;\n}\n\n.cost__list-item-content > :nth-child(2) {\n  border: none;\n}\n\n.cost__list-item-content > div {\n  flex: 1;\n  display: flex;\n  align-items: center;\n  justify-content: flex-end;\n  gap: 10px;\n  padding: 0 10px;\n}\n\n.cost__list-item-content > div > button {\n  padding: 10px 20px;\n  border: 1px solid #b2bac6;\n  border-radius: 8px;\n  background: transparent;\n  cursor: pointer;\n}\n\n.cost__list-item-content > div > :first-child {\n  border-color: #0c6b60;\n  color: #0c6b60;\n  font-size: 14px;\n  font-weight: 500;\n}\n\n.cost__list-item-content > div > :last-child {\n  border-color: #e0383d;\n  color: #e0383d;\n  text-align: center;\n  font-size: 14px;\n  font-weight: 500;\n}\n\n.cost__list-item-form {\n  position: relative;\n  width: 100%;\n  display: flex;\n  border-radius: 8px;\n  background: #dde1eb;\n  padding: 30px;\n  gap: 30px;\n  display: none;\n  animation: popup 0.1s ease-in-out;\n}\n\n.cost__list-item-form.active {\n  display: flex;\n}\n\n@keyframes popup {\n  0% {\n    opacity: 0;\n    transform: translateY(-50px);\n  }\n  100% {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n.cost__list-item-form-close {\n  position: absolute;\n  top: 15px;\n  right: 15px;\n  cursor: pointer;\n  background: transparent;\n  border: none;\n  font-size: 20px;\n}\n\n.cost__list-item-form > figure {\n  position: relative;\n  width: 281px;\n  height: 281px;\n  border-radius: 8px;\n  background: #fff;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.cost__list-item-form > figure.active > img {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n  border-radius: 8px;\n}\n\n.cost__list-item-form > figure label {\n  position: absolute;\n  bottom: 15px;\n  width: calc(100% - 30px);\n  height: 40px;\n  border-radius: 8px;\n  background: #a7acb7;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n\n  color: var(--White, #fff);\n  font-size: 16px;\n  font-weight: 600;\n  cursor: pointer;\n}\n\n.cost__list-item-form-inputs {\n  width: calc(100% - 311px);\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n  padding: 0 0 15px 0;\n}\n\n.cost__list-item-form-inputs input {\n  width: 100%;\n  height: 56px;\n  padding: 0 20px;\n  border-radius: 8px;\n  font-size: 16px;\n  font-weight: 500;\n}\n\n.cost__list-item-form-inputs textarea, .cost__form .cost__form-inputs textarea {\n   width: 100%;\n  height: 137px;\n  padding: 10px;\n  border-radius: 8px;\n  font-size: 16px;\n  font-weight: 500;\n  border: none;\n  outline: none;\n}\n\n.cost__list-item-form-inputs.v2 {\n  width: 100%;\n  display: flex;\n  flex-direction: row;\n  gap: 16px;\n}\n\n.cost__list-item-form-inputs.v2 > input {\n  width: calc((100% - 16px) / 2);\n}\n\n/* ------- cost__form ---------- */\n.cost__form {\n  width: 100%;\n  height: 0px;\n  display: flex;\n  background: #dde1eb;\n  padding: 0px 30px;\n  border-radius: 8px;\n  gap: 30px;\n  overflow: hidden;\n  transition: all 0.2s ease-in-out;\n}\n\n.cost__form.active {\n  height: 341px;\n  padding: 30px;\n}\n\n.cost__form.height_500.active\n{\n  height: 500px;\n}\n\n.cost__form > figure {\n  position: relative;\n  width: 281px;\n  height: 281px;\n  border-radius: 8px;\n  background: #fff;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.cost__form > figure > img.active {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n  border-radius: 8px;\n}\n\n.cost__form > figure label {\n  position: absolute;\n  bottom: 15px;\n  width: calc(100% - 30px);\n  height: 40px;\n  border-radius: 8px;\n  background: #a7acb7;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n\n  color: var(--White, #fff);\n  font-size: 16px;\n  font-weight: 600;\n  cursor: pointer;\n}\n\n.cost__form-inputs {\n  width: calc(100% - 311px);\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n}\n\n.cost__form-inputs > input {\n  width: 100%;\n  height: 56px;\n  padding: 0 20px;\n  border-radius: 8px;\n  font-size: 16px;\n  font-weight: 500;\n}\n\n.cost__form-inputs > div {\n  width: 100%;\n  display: flex;\n  flex-direction: row;\n  gap: 16px;\n}\n\n.cost__form-inputs > div > button {\n  width: calc((100% - 16px) / 2);\n  height: 56px;\n  padding: 0;\n  border: none;\n  border-radius: 8px;\n  background: #0c6b60;\n  color: var(--White, #fff);\n  font-size: 16px;\n  font-weight: 600;\n  cursor: pointer;\n}\n\n.cost__form-inputs > div > button[type=\"button\"] {\n  background: #e0383d;\n}\n\n@media (max-width: 1024px) {\n  .cost__menu {\n    display: none;\n  }\n\n  .cost__content {\n    width: 100%;\n  }\n}\n\n@media (max-width: 650px) {\n  .cost__header {\n    flex-wrap: wrap-reverse;\n    gap: 8px;\n  }\n\n  .cost__header > h2 {\n    inline-size: 100%;\n  }\n\n  .cost__header > button {\n    width: calc((100% - 16px) / 3);\n  }\n\n  .cost__header > div > button {\n    width: calc((100% - 16px) / 3);\n  }\n\n  .cost__list > li {\n    width: 100%;\n    display: flex;\n    align-items: center;\n    flex-wrap: wrap;\n  }\n\n  .cost__list-header > :nth-child(1) {\n    width: calc(70% - 20px) !important;\n    text-align: left;\n    padding: 0 10px;\n  }\n\n  .cost__list-header > :nth-child(2) {\n    width: 30% !important;\n    padding: 0 10px;\n  }\n\n  .cost__list-item-content > :nth-child(1) {\n    width: calc(70% - 20px) !important;\n    padding: 0 10px;\n  }\n\n  .cost__list-item-content > :nth-child(2) {\n    width: 30% !important;\n    padding: 0 10px;\n  }\n\n  .cost__list-item-content {\n    height: auto;\n    flex-wrap: wrap;\n    gap: 20px;\n    padding: 15px 0;\n  }\n\n  .cost__list-item-content > div {\n    width: 100%;\n    padding: 0 10px;\n  }\n\n  .cost__list-item-content > div > button {\n    max-width: 180px;\n    width: calc((100% - 10px) / 2);\n    height: 30px;\n    padding: 0;\n    font-size: 12px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
